import React, { createContext, useContext, useState, ReactNode, useMemo } from "react";

interface LoaderContextProps {
  show: boolean;
  setLoading: (show: boolean) => void;
}

const LoaderContext = createContext<LoaderContextProps | undefined>(undefined);

export const LoaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [show, setShow] = useState(false);

  const setLoading = (show: boolean) => setShow(show);
 const contextValue = useMemo(() => ({ show, setLoading }), [show]);
  return (
    <LoaderContext.Provider value={contextValue}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = (): LoaderContextProps => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoader must be used within a LoaderProvider");
  }
  return context;
};
